var map = {
	"./anm-card.png": 569,
	"./app-install-icon.webp": 1675,
	"./arrow.png": 570,
	"./btn-blue-m-v2.png": 571,
	"./btn-blue-m.png": 572,
	"./btn-white-m-v2.png": 573,
	"./btn-white-m.png": 574,
	"./dummy-1.png": 575,
	"./eeziepay.svg": 576,
	"./fcl.svg": 577,
	"./fpx-logo.svg": 578,
	"./game-blue.png": 579,
	"./game-img.png": 580,
	"./game-white.png": 581,
	"./global-language.svg": 582,
	"./ifm-logo.svg": 583,
	"./logo-anniversary.png": 584,
	"./logo-christmas.png": 585,
	"./logo-cny-dragon.png": 586,
	"./logo-cny.png": 587,
	"./logo-halloween.png": 588,
	"./logo-merdeka.png": 589,
	"./logo-mooncake.png": 590,
	"./logo-raya.png": 591,
	"./logo-uefa.png": 592,
	"./merchant-logo.png": 94,
	"./modal-bg.jpg": 593,
	"./number-bg.png": 594,
	"./pagcor.svg": 595,
	"./pool-bg.png": 596,
	"./side-bar-bg.png": 597,
	"./tether.svg": 598,
	"./x33-logo-wc.png": 599,
	"./x33-logo.png": 600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 781;